import { render } from "./commonArea.vue?vue&type=template&id=4e9b370c&ts=true"
import script from "./commonArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonArea.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e9b370c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e9b370c', __exports__)) {
    api.reload('4e9b370c', __exports__)
  }
  
  module.hot.accept("./commonArea.vue?vue&type=template&id=4e9b370c&ts=true", () => {
    api.rerender('4e9b370c', render)
  })

}


export default __exports__